import { create } from 'zustand'
import BottomSheetWrapper from '../../BottomSheetWrapper'
let BottomSheet = BottomSheetWrapper.BottomSheet
let BottomSheetScrollView = BottomSheetWrapper.BottomSheetScrollView
let BottomSheetView = BottomSheetWrapper.BottomSheetView
import { TouchableWithoutFeedback, KeyboardAvoidingView, Keyboard, Animated, View, Dimensions, Platform, ScrollView } from 'react-native'
import { getPlatform } from '../../../utils/platformUtils'
import styles from './BottomSheetContextStyles'

import React, { useState, useEffect } from 'react'
import { useDimensionsStore } from '@/redux/zustand/useDimensionStore'
import { useAndroidNavBarHeight } from '../hooks/useAndroidNavBarHeight'
const height = Dimensions.get('window').height

const useBottomSheetStore = create((set) => ({
    sheetRef: null,
    modalContent: null,
    isOpen: null,
    isModalClosableSlice: null, // deslizando --- puedo cerrar el modal deslizando ? true: se puede cerrar --- false: no se puede cerrar
    isModalClosableTouch: null, // tocando fuera del widget ---puedo cerrar el modal deslizando ? true: se puede cerrar --- false: no se puede cerrar
    isModalClosable: null, // cerrar general --- puedo cerrar el modal ? true: se puede cerrar --- false: no se puede cerrar
    keyboardShouldPersistTaps: 'never',
    isScrollableList: null,
    openBottomSheet: (
        content,
        snapPoints,
        isModalClosable = true,
        isModalClosableTouch = true,
        isModalClosableSlice = true,
        keyboardShouldPersistTaps = 'never',
        isScrollableList = false,
    ) => {
        // console.trace("openBottomSheet llamado con:", { content, snapPoints, isModalClosable, isModalClosableTouch, isModalClosableSlice, keyboardShouldPersistTaps });

        if (content == undefined || content == null) {
            console.warn('El contenido del BottomSheet es undefined o null.')
            return
        }

        // if (useBottomSheetStore.getState().isOpen) {
        //     console.warn("Ya hay un BottomSheet abierto.");
        //     return;
        // }

        set((state) => ({
            sheetRef: state.sheetRef,
            modalContent: content,
            snapPoints: snapPoints,
            isOpen: true,
            keyboardShouldPersistTaps: keyboardShouldPersistTaps,
            isModalClosableSlice: isModalClosableSlice,
            isModalClosableTouch: isModalClosableTouch,
            isModalClosable: isModalClosable,
            originSnap: snapPoints,
            isScrollableList: isScrollableList,
        }))
    },
    closeBottomSheet: async (l) => {
        console.log('CLOSE', l)
        console.log('Called closeBottomSheet with', {
            isOpen: useBottomSheetStore.getState().isOpen,
            content: useBottomSheetStore.getState().content,
        })

        // @fixme algun dia agregue este parametro porque se llama dos veces y no encuentro donde solo que cuando viene undefine viene de un lado no mapeado
        if (l != undefined) {
            Keyboard.dismiss()
            // Agregar un retraso opcional
            set({ sheetRef: null, modalContent: null, isOpen: false, originSnap: null })
            useBottomSheetStore.subscribe((state) => {})
        }
    },
    updateSnapPoints: (snapPoints) => {
        set(() => ({ snapPoints: snapPoints }))
    },
    originSnap: null,
}))

export const BottomSheetProvider = ({ children }) => {
    // Desactivar BottomSheet en web temporalmente debido a errores de React Native Reanimated
    // if (getPlatform().OS === 'web') {
    //     return children
    // }

    const {
        sheetRef,
        modalContent,
        closeBottomSheet,
        snapPoints,
        keyboardShouldPersistTaps,
        isModalClosableSlice,
        isModalClosableTouch,
        isModalClosable,
        updateSnapPoints,
        isScrollableList,
    } = useBottomSheetStore()

    // Estados adicionales para manejar el teclado
    const [keyboardOpen, setKeyboardOpen] = useState(false)
    const [keyboardHeight, setKeyboardHeight] = useState(0)
    let updatedHeight = (100 * keyboardHeight) / height
    const [enableDismissOnClose, setEnableDismissOnClose] = useState(true)

    const updateSnaps = () => {
        let oSnap = useBottomSheetStore.getState().originSnap
        if (oSnap == null) {
            return
        }
        let currentSnap = parseInt(oSnap[0].replace('%', ''), 10)
        let newSnap = Math.round(updatedHeight) + currentSnap
        updateSnapPoints([newSnap.toString() + '%'])
    }
    // cuando toco afuera se ejecuta
    const handleOverlayPress = () => {
        console.log('handleOverlayPress llamado con', { isModalClosable, isModalClosableTouch })
        if (isModalClosable && isModalClosableTouch) {
            // se puede cerrar tocando afuera ?
            closeBottomSheet(false)
            setKeyboardOpen(false)
            setKeyboardHeight(0)
        } else {
            console.log(`No se puede cerrar: isModalClosable: ${isModalClosable} - isModalClosableTouch: ${isModalClosableTouch}`)
        }

        // if (enablePanDownToClose != undefined && enablePanDownToClose == true) {
        // } else {
        //     if (enablePanDownToClose != undefined) {
        //         console.log('---> No cierro hoja', enablePanDownToClose)
        //     } else {
        //         closeBottomSheet(true)
        //         console.log('---> Cierro hoja al tocar', blockTouchToClose)
        //     }
        // }
    }
    useEffect(() => {
        if (getPlatform().OS == 'android') {
            updateSnaps()
        }
    }, [keyboardHeight])

    const closeBottomAndSetData = () => {
        closeBottomSheet(false)
        setKeyboardOpen(false)
        setKeyboardHeight(0)
    }
    // Efectos para manejar el estado del teclado
    useEffect(() => {
        if (getPlatform().OS != 'android') return

        const keyboardDidShowListener = Keyboard.addListener('keyboardDidShow', (e) => {
            if (useBottomSheetStore.getState().isOpen) {
                setKeyboardOpen(true)
                setKeyboardHeight(e.endCoordinates.height)
                console.log('key', e.endCoordinates.height)
            }
        })

        const keyboardDidHideListener = Keyboard.addListener('keyboardDidHide', () => {
            if (useBottomSheetStore.getState().isOpen) {
                console.log('key')
                setKeyboardOpen(false)
                setKeyboardHeight(0)
                // closeBottomSheet(false) // Cierra el modal solo si está abierto
            }
        })

        return () => {
            keyboardDidShowListener.remove()
            keyboardDidHideListener.remove()
            setKeyboardOpen(false)
            setKeyboardHeight(0)
        }
    }, [])

    useEffect(() => {
        if (keyboardOpen) {
            setEnableDismissOnClose(false)
        }
    }, [keyboardOpen])
    useEffect(() => {
        if (modalContent == null) {
            setKeyboardOpen(false)
            setKeyboardHeight(0)
        }
    }, [modalContent])

    // useEffect(() => {
    //     if (!enableDismissOnClose && keyboardOpen) {
    //         setTimeout(() => {
    //             setEnableDismissOnClose(true);
    //         }, 10);
    //     }
    // }, [enableDismissOnClose, keyboardOpen]);
    const navBarHeight = useAndroidNavBarHeight()
    const width = useDimensionsStore((state) => state.width)
    const heightWeb = useDimensionsStore((state) => state.height)

    if (Platform.OS == 'web') {
        React.useEffect(() => {
            if (modalContent) {
                document.body.style.overflow = 'hidden'
            } else {
                document.body.style.overflow = ''
            }
            return () => {
                document.body.style.overflow = ''
            }
        }, [modalContent])
        return (
            <>
                {children}
                {modalContent && (
                    <View
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100vw',
                            height: '100vh',
                            zIndex: 9999,
                            overflow: 'hidden',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <TouchableWithoutFeedback onPress={() => handleOverlayPress()}>
                            <Animated.View
                                style={{ ...styles.overlay, ...styles.opacity, ...StyleSheet.absoluteFillObject, zIndex: 9998 }}
                                activeOpacity={1}
                            />
                        </TouchableWithoutFeedback>
                        <ScrollView
                            style={{
                                maxWidth: 790,
                                borderRadius: 25,
                                backgroundColor: 'white',
                                alignSelf: 'center',
                                margin: 16,
                                flexGrow: 0,
                                maxHeight: '90vh',
                                overflow: 'auto',
                                zIndex: 10000,
                            }}
                            contentContainerStyle={{
                                maxHeight: '90vh',
                            }}
                            showsVerticalScrollIndicator={false}
                        >
                            {modalContent}
                            {keyboardOpen && <View style={{ height: keyboardHeight }}></View>}
                        </ScrollView>
                    </View>
                )}
            </>
        )
    }
    return (
        <>
            {children}
            {modalContent && (
                <>
                    <TouchableWithoutFeedback onPress={() => handleOverlayPress()}>
                        <Animated.View style={{ ...styles.overlay, ...styles.opacity }} activeOpacity={1} />
                    </TouchableWithoutFeedback>

                    {!isScrollableList ? (
                        <>
                            {snapPoints ? (
                                <BottomSheet
                                    ref={sheetRef}
                                    index={0}
                                    //napPoints={snapPoints}
                                    // enableDynamicSizing
                                    enableDynamicSizing // 👈 deja que el tamaño del contenido se ajuste solo
                                    maxDynamicContentSize={700}
                                    onClose={() => closeBottomAndSetData()}
                                    android_keyboardInputMode='adjustResize'
                                    detached={false}
                                >
                                    <BottomSheetView style={styles.containerFlex}>
                                        {modalContent}
                                        <View style={{ height: navBarHeight }} />
                                    </BottomSheetView>
                                    {keyboardOpen && <View style={{ height: keyboardHeight }}></View>}
                                </BottomSheet>
                            ) : (
                                <BottomSheet
                                    ref={sheetRef}
                                    index={0}
                                    enableDynamicSizing={true} // para que se ajuste al contenido del modal
                                    onClose={() => closeBottomAndSetData()}
                                >
                                    <BottomSheetScrollView keyboardShouldPersistTaps='always' style={styles.containerFlex}>
                                        {/* <BottomSheetScrollView style={styles.containerFlex}> */}
                                        {modalContent}
                                        {keyboardOpen && <View style={{ height: keyboardHeight }}></View>}
                                        <View style={{ height: navBarHeight }} />
                                        {/* </BottomSheetScrollView> */}
                                    </BottomSheetScrollView>
                                </BottomSheet>
                            )}
                        </>
                    ) : (
                        <BottomSheet
                            ref={sheetRef}
                            index={0}
                            snapPoints={snapPoints ? snapPoints : undefined}
                            enableDynamicSizing={snapPoints ? false : true} // para que se ajuste al contenido del modal
                            {...(!snapPoints ? { maxDynamicContentSize: 700 } : {})}
                            onClose={() => closeBottomAndSetData()}
                        >
                            {modalContent}
                            {keyboardOpen && <View style={{ height: keyboardHeight }}></View>}
                            <View style={{ height: navBarHeight }} />
                        </BottomSheet>
                    )}
                </>
            )}
        </>
    )
}

export const useBottomSheet = useBottomSheetStore

/*
    const { openBottomSheet } = useBottomSheet() //* hook para abrir el modal, se debe llamar a este hook en la vista en donde se quiera abrir el modal


    const handlePress = () => {
        openBottomSheet(
            <View>
                <Text>Hola desde post list</Text>
            </View>
        )
    }

    //* Ejemplo de una funcion que ejecuta el hook para abrir el modal y por param le pasa contenido a renderizar dentro de el..
    //* Se utiliza la libreria "zustand" para el manejo de estados, es mucho mas sencilla de utilizar que context, la app no tiene muchas cosas hechas con context, se podria remplazar por zustand, facil de usar y sencillo de leer

*/
